import { useGetUserZoneFollowsQuery } from '../graphql/queries/getUserZoneFollows.types'
import { useLoading } from 'shared/hooks'
import { LabelFollow } from 'shared/__gql-types'

export const useUserZoneFollows = () => {
  const { data, loading } = useGetUserZoneFollowsQuery()

  const followedZonesByZoneId = (data?.getUserLabelFollows ?? []).reduce((res: Record<string, LabelFollow>, followed) =>
    ({ ...res, ...(followed?.label_id && { [followed.label_id]: followed }) }), {})
  const getZoneFollowed = (zoneId: string) => !!followedZonesByZoneId?.[zoneId]

  useLoading({ isLoading: loading })

  return {
    getZoneFollowed,
    followedZones: data?.getUserLabelFollows ?? []
  }
}
